export default __webpack_public_path__ + "static/media/news.45f36c7c.jpg";